export default {"src":"/_next/static/media/cricket-bat.37d48872.svg","height":14,"width":14};